export default __webpack_public_path__ + "static/hranice-cssr-df68586ca1b5156348eadc0a8db2c969.avif";